import { useTranslation } from 'react-i18next';
import classes from './SearchCriteriaLine.module.css';

interface SearchCriteriaLineProps {
  /** Критерии выполненного поиска одной строкой: «п. Озерный · Пшеница 4 класс · Протеин ≥ 13 % · любая предоплата». */
  readonly criteria: string;
  /** Число строк выдачи; `null` — выдача ещё загружается. */
  readonly count: number | null;
  /** Форма изменена после поиска: выдача относится к прежним критериям. */
  readonly stale: boolean;
}

// Строка над выдачей поиска лучшей цены (общая для продавца и покупателя). Сообщает, сколько найдено и для каких
// критериев; после изменения формы добавляет, что выдача устарела, — подпись выдачи при этом остаётся. Живая область
// смонтирована всё время поиска, поэтому программа чтения с экрана объявляет каждое изменение.
export default function SearchCriteriaLine({ criteria, count, stale }: SearchCriteriaLineProps) {
  const { t } = useTranslation();
  return (
    <div role="status">
      {stale ? <p className={classes.stale}>{t('app.bestPrice.results.stale')}</p> : null}
      {count != null ? <p className={classes.line}>{t('app.bestPrice.results.shownFor', { count, criteria })}</p> : null}
    </div>
  );
}
